import React, {Component, Fragment} from "react";
import folder from './icons/folder.png';
import briefcase from './icons/briefcase.png';
import {getFileIcon, getOverlay} from "./icons/FileIcon";
import {Popover, PopoverBody, PopoverHeader} from "reactstrap";
import {getData} from "../../../api/doLogin";
import "../Briefcase.css";
import {isMobile, isMobileDevice, mobileAndTabletCheck} from "../../../constants/MiscData";

export default class FileEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popover: false,
      notes: null
    }
  }

  iconType(type, name, status) {
    switch (type) {
      case "briefcase":
        return <div style={{height: 48, width: 48}}>
          <img src={briefcase} alt={name} style={{width: 48, height: 48, position: "absolute"}}/>
          {this.doOverlay(status)}
        </div>;
      case "folder":
        return <div style={{height: 48, width: 48}}>
          <img src={folder} alt={name} style={{width: 48, height: 48, position: "absolute"}}/>
          {this.doOverlay(status)}
        </div>;
      default:
        return <div style={{height: 48, width: 48}}>
          <img src={getFileIcon(name)} alt={name} style={{width: 48, height: 48, position: "absolute"}}/>
          {this.doOverlay(status)}
        </div>;
    }
  }

  doOverlay(status) {
    const overlay = getOverlay(status);
    if (overlay) {
      return <img src={overlay} style={{width: 48, height: 48, position: "absolute"}}/>
    } else {
      return null;
    }
  }

  togglePreview(val, fid, id) {
    var self = this;
    if (isMobile || isMobileDevice || mobileAndTabletCheck()) return;
    this.setState({popover: val}, () => {
      if (val && this.state.notes === null) {
        getData(`briefcase/0/${this.props.id}/notes`)
          .then((data) => {
            if (data.status === "Success") {
              self.setState({notes: data.data && data.data.file && data.data.file.notes || ""});
            } else {
              self.setState({notes: ""});
            }
          })
          .catch((err) => {
          });
      }
    })
  }


  render() {
    const {id, name, type, onClick, status, entry, extra} = this.props;
    const showCBBBG = entry && entry.cbAgency && entry.cbAgency > 0 || false;
    let fileStyle = {display: "block", width: 100, height: 100, cursor: "pointer"};
    if (showCBBBG) {
      fileStyle = {...fileStyle, backgroundColor: "rgba(160, 32, 240, 0.1)"};
    }
    return <Fragment>
      <div id={`FileEntry-${id}`} style={fileStyle}
           onClick={() => {
             onClick && onClick(type, id, extra);
           }}
           onMouseOver={() => type !== "folder" && type !== "briefcase" && this.togglePreview(true)}
           onMouseOut={() => type !== "folder" && type !== "briefcase" && this.togglePreview(false)}
      >
        {this.props.showCheck && (
          <input type="checkbox" checked={this.props.checked || false} readOnly={true}/>
        )}
        <div style={{width: "100%", textAlign: "center"}}>
          {this.iconType(type, name, status)}
        </div>
        <div style={{width: "100%", textAlign: "center", fontSize: 11}}>{name}</div>
      </div>
      {type === "file" && window.innerWidth > 768 && (
        <Popover placement={"left"} isOpen={this.state.popover} target={`FileEntry-${id}`}
                 style={{maxHeight: "100vh"}}
                 toggle={() => {
                 }}>
          <PopoverHeader>{entry.filename}</PopoverHeader>
          <PopoverBody style={{
            height: "calc(100%-200px)",
            overflow: "hidden"
          }}>
            <div>Source: {entry.source}</div>
            {this.state.notes === null ? (
              <div className="sk-double-bounce" style={{opacity: 1}}>
                <div className="sk-child sk-double-bounce1"></div>
                <div className="sk-child sk-double-bounce2"></div>
              </div>
            ) : (
              <div
                style={{
                  whiteSpace: "pre-line"
                }}>Comments: {this.state.notes && this.state.notes.toString() || ""}</div>
            )}
          </PopoverBody>
        </Popover>
      )}
    </Fragment>
  }
}


// WEBPACK FOOTER //
// ./src/containers/Briefcase/entry/FileEntry.js